import styled from 'styled-components';
import { getSpace, mq, getTransition } from '../../../stylesheets/tools';

const StyledCrossTeasers = styled.div`
  margin: ${getSpace('xxxl')} 0;

  .crossTeasers__first-teaser .container__wrapper {
    display: flex;
    justify-content: center;
  }

  .crossTeasers__headline {
    margin-bottom: ${getSpace('m')};
  }

  .crossTeasers__other-teasers {
    position: relative;
    z-index: 91;
    overflow: hidden;
    padding: 160px 0;
    margin: -110px 0 -160px 0;
  }

  .crossTeasers__teaser {
    position: relative;
    box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.1);
    ${getTransition()}

    &.entering {
      z-index: 2;
    }

    &.entered {
      z-index: 3;
    }

    &.exiting {
      z-index: 3;
    }

    &.exited {
      z-index: 2;

      .tiltedTeaser__link {
        pointer-events: none;
      }
    }
  }

  .crossTeasers__teaser[data-teaser-position='1'] {
    &.entering,
    &.exiting {
      transform: rotate(-3deg) translateY(-20px);

      ${mq('m')} {
        transform: rotate(-3deg) translateY(-80px);
      }
    }

    &.entered,
    &.exited {
      transform: rotate(0);
    }
  }

  .crossTeasers__teaser[data-teaser-position='2'] {
    &.entering,
    &.exiting {
      transform: rotate(3deg) translateY(20px);

      ${mq('m')} {
        transform: rotate(3deg) translateY(80px);
      }
    }

    &.entered,
    &.exited {
      transform: rotate(0);
    }
  }
`;

export default StyledCrossTeasers;
